import { EStoreExecutorTable, ID, JobTemplate } from "@project/shared-types";
import React, { useEffect, useRef, useState } from "react";
import { _colorText, _sizeText } from "../../core/core";
import { InputDatePicker } from "../InputDatePicker/InputDatePicker";
import { InputNew } from "../InputNew/InputNew";
import { InputImageLoader } from "../inputs/InputImageLoader";
import { Text } from "../texts/text";
import "./OrderNewJob.css";

interface OrderNewJobProps {
  id?: number;
  job: JobTemplate;
  onUpdateTask?: (
    id: number,
    text: string,
    date: number,
    filename: string
  ) => void;
}
export const OrderNewJob: React.FC<OrderNewJobProps> = ({
  id = 0,
  job,
  onUpdateTask,
}) => {
  const [date, setDate] = useState<number>(
    job.date_public !== 0 ? job.date_public : +new Date()
  );
  const [text, setText] = useState<string>(job.text || "");
  const [file, setFile] = useState<File | null>(null);
  const [filepath, setFilePath] = useState<string>("");

  const hasMounted = useRef(false);

  // Обновляем состояние, если job изменяется
  useEffect(() => {
    if (job.date_public !== date) {
      setDate(job.date_public !== 0 ? job.date_public : +new Date());
    }
    if (job.text !== text) {
      setText(job.text || "");
    }
  }, [job]);

  // Вызываем onUpdateTask при изменении text, date или filepath
  useEffect(() => {
    if (hasMounted.current) {
      if (onUpdateTask) {
        onUpdateTask(id, text, date, filepath);
      }
    } else {
      hasMounted.current = true;
    }
  }, [text, date, filepath]);

  // Обработка загрузки файла
  const handleLoadImage = (file_id: ID) => {
    setFilePath(file_id);
  };

  return (
    <div key={id} className="order-task">
      <div className="order-task-header">
        <div className="order-task-header-group">
          <Text size={_sizeText.m} color={_colorText.black}>
            Новое задание
          </Text>
          <Text size={_sizeText.m} color={_colorText.neutral}>
            №{id + 1}
          </Text>
        </div>
      </div>
      <div className="order-task-body">
        <InputNew
          value={text}
          color={'inverse'}
          onChange={(e) => setText(e.target.value)}
          placeholder="Текст отзыва"
        />
        <InputDatePicker
          value={date}
          setValue={setDate}
          labelOutside="Дата начала"
        />
        <InputImageLoader
          placeholder="Фото к отзыву"
          onLoad={handleLoadImage}
          table_id={id.toString()}
          table_type={EStoreExecutorTable.JOBS}
        />
      </div>
    </div>
  );
};
